import { PROMO_SLUGS } from '@constants/promoSlugs';
import { FlaggAdmin } from 'flagg/dist/react';
import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { AdminCreateUser } from './pages/AdminCreateUser/AdminCreateUser';
import { AdminLogin } from './pages/AdminLogin/AdminLogin';
import { AdminUsers } from './pages/AdminUsers/AdminUsers';
import { AdminRoute } from './components/AdminRoute/AdminRoute';
import { PrivateRoute } from './components/PrivateRoute/PrivateRoute';
import { RouteNames } from './constants/RouteNames';
import { Page } from './Layouts/Page/Page';
import { MeetingLink } from './pages/MeetingLink/MeetingLink';
import { MeetingSelect } from './pages/MeetingSelect/MeetingSelect';
import { PostMeeting } from './pages/PostMeeting/PostMeeting';
import { PromoSlugPage } from './pages/PromoSlugPage';
import RoomPage from './pages/RoomPage/RoomPage';
import { SetPassword } from './pages/SetPassword/SetPassword';
import { SignIn } from './pages/SignIn/SignIn';

const LicensesPage = React.lazy(() => import('./pages/licenses/LicensesPage'));

export interface IRoutesProps {}

export const Routes: React.FC<IRoutesProps> = () => {
  return (
    <Switch>
      <Route exact path={RouteNames.ROOT}>
        <Redirect to="/create" />
      </Route>
      <PrivateRoute exact path={RouteNames.CREATE_MEETING} render={(props) => <MeetingSelect {...props} />} />

      <Route exact path={RouteNames.SIGN_IN} component={SignIn} />
      <Route exact path={RouteNames.SET_PASSWORD} component={SetPassword} />
      <Route exact path={RouteNames.ADMIN_ROOT}>
        <Redirect to={RouteNames.ADMIN_LOGIN} />
      </Route>
      <Route exact path={RouteNames.ADMIN_CREATE_USER} component={AdminCreateUser} />
      <Route exact path={RouteNames.ADMIN_LOGIN} component={AdminLogin} />

      <Route exact path={RouteNames.MEETING_LINK} component={MeetingLink} />

      <AdminRoute
        path={RouteNames.FEATURE_FLAGS}
        render={({ history }) => <FlaggAdmin onDone={() => history.push('/')} />}
      />
      <AdminRoute exact path={RouteNames.ADMIN_USERS} render={() => <AdminUsers />} />

      <Route path={RouteNames.LICENSES}>
        <React.Suspense fallback={<Page isLoading />}>
          <LicensesPage />
        </React.Suspense>
      </Route>

      {PROMO_SLUGS.map((slug, index) => (
        <Route key={`${slug}_${index}`} path={`/${slug}`} component={PromoSlugPage} />
      ))}

      <Route path="/:roomRoute/post_meeting" component={PostMeeting} />
      <Route
        path="/:roomRoute"
        render={(renderProps) => {
          return <RoomPage roomRoute={renderProps.match.params.roomRoute} />;
        }}
      />
    </Switch>
  );
};
